var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class VideoQualitySettings {
    constructor(videoWidth, videoHeight, videoFrameRate) {
      this.videoWidth = videoWidth;
      this.videoHeight = videoHeight;
      this.videoFrameRate = videoFrameRate;
    }
    equals(other) {
      return this.videoWidth === other.videoWidth && this.videoHeight === other.videoHeight && this.videoFrameRate === other.videoFrameRate;
    }
  }
  exports.default = VideoQualitySettings;
  VideoQualitySettings.VideoDisabled = new VideoQualitySettings(0, 0, 0);
  VideoQualitySettings.VideoResolutionHD = new VideoQualitySettings(1280, 720, 30);
  VideoQualitySettings.VideoResolutionFHD = new VideoQualitySettings(1920, 1080, 30);
  VideoQualitySettings.VideoResolutionUHD = new VideoQualitySettings(3840, 2160, 30);
  //# sourceMappingURL=VideoQualitySettings.js.map
  return exports;
}